import { validation } from '@/util/validation.js';
export default {
  submitText: '充值',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
    },
    {
      label: '车场名称',
      type: 'input',
      prop: 'parkingLotName',
      editDisabled: true,
      disabled: true,
    },
    {
      label: '商家名称',
      prop: 'shopName',
      disabled: true,
      rules: [{
        required: false,
        message: '请输入商家名称',
        trigger: 'blur',
      }],
    },
    {
      label: '责任人',
      prop: 'shopResponsiblePerson',
      disabled: true,
      rules: [{
        required: true,
        message: '请输入商家责任人',
        trigger: 'blur',
      }],
    },
    {
      label: '手机号码',
      prop: 'shopPersonPhone',
      disabled: true,
      rules: [{
        required: true,
        message: '请输入责任人手机号码',
        trigger: 'blur',
      }],
    },
    {
      label: '商家余额',
      prop: 'shopBalance',
      span: 24,
      disabled: true,
      rules: [
        {
          required: false,
          message: '0.00',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '充值金额',
      prop: 'rechargeAmount',
      slot:true,
      formslot: true,
      rules: [{
        required: true,
        message: '请输入充值金额',
        trigger: 'blur',
      }],
    },
    {
      label: '优惠折扣',
      type: 'select',
      prop: 'discountType',
      slot:true,
      formslot: true,
      rules: [{
        required: false,
        message: '请输入责任人手机号码',
        trigger: 'blur',
      }],
    },
    {
      label: '优惠金额',
      prop: 'discountAmount',
      disabled: true,
      rules: [
        {
          required: false,
          message: '请输入应缴金额',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '实收金额',
      prop: 'payAmount',
      disabled: true,
      rules: [
        {
          required: false,
          message: '请输入实收金额',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '支付方式',
      prop: 'payType',
      type: 'select',
      slot: true,
      dicData: [
        {
          label: '现金',
          value: 0,
        },
      ],
      rules: [
        {
          required: true,
          message: '请选择支付方式',
          trigger: 'blur',
        },
      ],
    },
  ],
};
